/**
 * AdminEmptyState — Uniforme lege-status voor lijsten, filters, drawers.
 *
 * Voorbeeld:
 *   <AdminEmptyState
 *     icon={Users}
 *     title="Geen debiteuren in deze weergave"
 *     description="Pas het filter aan of maak een nieuwe factuur."
 *     action={<Button>Nieuwe factuur</Button>}
 *   />
 */
import React from "react";

export default function AdminEmptyState({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
  testid = "admin-empty-state",
}) {
  return (
    <div
      className={
        `flex flex-col items-center justify-center text-center bg-white border border-dashed border-slate-300 rounded-2xl ` +
        (compact ? "p-6" : "p-10 sm:p-12")
      }
      data-testid={testid}
    >
      {Icon ? (
        <div className="w-14 h-14 rounded-2xl bg-brand-50 border border-brand-100 text-brand-500 flex items-center justify-center mb-4">
          <Icon className="w-6 h-6" />
        </div>
      ) : null}
      {title ? (
        <div className="font-chivo font-bold text-brand-900 text-base mb-1">{title}</div>
      ) : null}
      {description ? (
        <p className="text-sm text-ink-500 max-w-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
